<template>
  <div class="pt-0 pb-1">
    <!-- ── KPI Tiles ── -->
    <div
      v-if="isV4CalculationEngine !== null"
      class="sw-tile-strip"
      :class="isV4CalculationEngine ? 'sw-tile-strip-three' : ''"
    >
      <!-- Style Analysis -->
      <div class="sw-count-tile tile-blue card d-flex sw-tile-clickable" @click="$router.push({ name: 'Styles' })">
        <div class="sw-tile-label">{{ $t("dashboard.styleAnalysis") }}</div>
        <div class="sw-tile-mid">
          <div class="sw-tile-icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 19 18.838">
              <path
                id="Path_476"
                data-name="Path 476"
                d="M19.2,21.583H7.8v.95a.476.476,0,0,0,.475.475h10.45a.476.476,0,0,0,.475-.475Zm-.522-16.8A4.937,4.937,0,0,1,13.5,8.758,4.937,4.937,0,0,1,8.323,4.787L6.309,5.68a1.8,1.8,0,0,0-.347.2l1.5,2.631A2.552,2.552,0,0,1,7.8,9.789V20.633H19.2V9.789a2.6,2.6,0,0,1,.337-1.273l1.5-2.631a1.954,1.954,0,0,0-.347-.2ZM4.148,11.442l-.133.527a.476.476,0,0,0,.247.541L6.85,13.8V12.6Zm18.7,0L20.15,12.6v1.2l2.589-1.292a.471.471,0,0,0,.247-.541l-.133-.527ZM4.381,10.506l2.47,1.059V9.789a1.6,1.6,0,0,0-.214-.8l-1.3-2.27a1.443,1.443,0,0,0-.057.19ZM20.15,11.565l2.47-1.059-.9-3.6c-.014-.066-.038-.128-.057-.19l-1.3,2.27a1.637,1.637,0,0,0-.214.8v1.776Zm-2.859-7.4.494.218a.107.107,0,0,1,0,.033A4.065,4.065,0,0,1,13.5,7.8a4.062,4.062,0,0,1-4.28-3.377.07.07,0,0,0,0-.033l.494-.218a3.615,3.615,0,0,0,.826,2A3.713,3.713,0,0,0,13.5,7.338a3.713,3.713,0,0,0,2.964-1.164,3.578,3.578,0,0,0,.826-2Zm-6.626.019a2.555,2.555,0,0,0,.584,1.354,2.829,2.829,0,0,0,2.251.841,2.829,2.829,0,0,0,2.251-.841,2.541,2.541,0,0,0,.584-1.354,7.881,7.881,0,0,1-2.836.769A7.881,7.881,0,0,1,10.665,4.189Z"
                transform="translate(-4.001 -4.17)"
                fill="#00aeef"
                fill-rule="evenodd"
              />
            </svg>
          </div>
          <div class="sw-tile-value-row">
            <span class="sw-tile-value"> {{ formatNumber(summaryTilesData?.styleAnalysis?.count) }} </span>
          </div>
        </div>
        <span class="sw-tile-tag">{{
          getPreview(summaryTilesData?.styleAnalysis?.latestStyleNames, 1, summaryTilesData?.styleAnalysis?.count)
        }}</span>
      </div>

      <!-- No. of Customers -->
      <div class="sw-count-tile tile-teal card d-flex">
        <div class="sw-tile-label">{{ $t("dashboard.noOfCustomers") }}</div>
        <div class="sw-tile-mid">
          <div class="sw-tile-icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14.143" viewBox="0 0 22 14.143">
              <path
                id="Path_477"
                data-name="Path 477"
                d="M47,117.893a2.947,2.947,0,1,0-3-2.946A2.982,2.982,0,0,0,47,117.893Zm-8,0a2.947,2.947,0,1,0-3-2.946A2.982,2.982,0,0,0,39,117.893Zm0,2.161c-2.35,0-7,1.129-7,3.438v2.652H46.143v-2.652C46.143,121.183,41.35,120.054,39,120.054Zm8,.54a5.337,5.337,0,0,0-.857.049,2.928,2.928,0,0,1,1.571,2.848v2.652H54v-2.652C54,121.183,49.35,120.594,47,120.594Z"
                transform="translate(-32 -112)"
                fill="#1ab394"
              />
            </svg>
          </div>
          <div class="sw-tile-value-row">
            <span class="sw-tile-value">{{ formatNumber(summaryTilesData?.customers?.count) }} </span>
          </div>
        </div>
        <span class="sw-tile-tag">{{
          getPreview(summaryTilesData?.customers?.topCustomerNames, 3, summaryTilesData?.customers?.count)
        }}</span>
      </div>

      <!-- Product Type -->
      <div class="sw-count-tile tile-orange card d-flex">
        <div class="sw-tile-label">{{ $t("dashboard.productType") }}</div>
        <div class="sw-tile-mid">
          <div class="sw-tile-icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16.5 14.143">
              <path
                id="Path_478"
                data-name="Path 478"
                d="M65.321,104.714H51.179v7.661a1.768,1.768,0,0,0,1.768,1.768H63.554a1.769,1.769,0,0,0,1.768-1.768Zm-8.839,2.357h3.536a.589.589,0,1,0,0-1.179H56.482a.589.589,0,1,0,0,1.179Zm-5.3-3.536H65.321a1.178,1.178,0,0,0,1.179-1.179v-1.179A1.178,1.178,0,0,0,65.321,100H51.179A1.178,1.178,0,0,0,50,101.179v1.179A1.178,1.178,0,0,0,51.179,103.536Z"
                transform="translate(-50 -100)"
                fill="#fd7e14"
                fill-rule="evenodd"
              />
            </svg>
          </div>
          <div class="sw-tile-value-row">
            <span class="sw-tile-value">{{ formatNumber(summaryTilesData?.productType?.count) }}</span>
          </div>
        </div>
        <span class="sw-tile-tag">
          {{ $t("dashboard.productCatCount", { count: summaryTilesData?.productType?.productCategoriesCount }) }}
        </span>
      </div>

      <!-- Settings -->
      <div
        v-if="!isV4CalculationEngine"
        class="sw-count-tile tile-grey card d-flex sw-tile-clickable"
        @click="$router.push({ name: 'systemConfiguration', query: { expandSections: 'true' } })"
      >
        <div class="sw-tile-label">{{ $t("dashboard.settings") }}</div>
        <div class="sw-tile-mid">
          <div class="sw-tile-icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
              <path
                id="cog"
                d="M12,9A3,3,0,0,0,9,6,3,3,0,0,0,6,9a3,3,0,0,0,3,3,3,3,0,0,0,3-3Zm6-1.278v2.6a.451.451,0,0,1-.094.269.358.358,0,0,1-.235.153l-2.168.328a7.479,7.479,0,0,1-.457,1.066q.41.586,1.254,1.617a.453.453,0,0,1,.117.293.391.391,0,0,1-.105.269,11.934,11.934,0,0,1-1.16,1.266q-.843.832-1.1.832a.572.572,0,0,1-.3-.105l-1.617-1.266a6.7,6.7,0,0,1-1.066.446,19.108,19.108,0,0,1-.34,2.18A.394.394,0,0,1,10.3,18H7.7a.443.443,0,0,1-.287-.1.346.346,0,0,1-.134-.251L6.95,15.492a7.255,7.255,0,0,1-1.055-.434L4.242,16.313a.421.421,0,0,1-.293.105.4.4,0,0,1-.293-.129A15.457,15.457,0,0,1,1.723,14.32a.458.458,0,0,1-.082-.269.451.451,0,0,1,.094-.269q.176-.246.6-.78t.633-.826a5.8,5.8,0,0,1-.48-1.16L.34,10.7a.369.369,0,0,1-.246-.146A.446.446,0,0,1,0,10.278v-2.6a.451.451,0,0,1,.094-.269.354.354,0,0,1,.223-.153L2.5,6.926a5.784,5.784,0,0,1,.457-1.078Q2.484,5.18,1.7,4.231a.441.441,0,0,1-.117-.282.494.494,0,0,1,.105-.27A11.6,11.6,0,0,1,2.842,2.42q.85-.838,1.107-.838a.5.5,0,0,1,.3.117L5.871,2.953a6.7,6.7,0,0,1,1.067-.445,19.108,19.108,0,0,1,.34-2.18A.394.394,0,0,1,7.7,0h2.6a.443.443,0,0,1,.287.1.348.348,0,0,1,.135.252l.328,2.157a7.255,7.255,0,0,1,1.054.434l1.664-1.254a.38.38,0,0,1,.281-.105.453.453,0,0,1,.293.117,16.054,16.054,0,0,1,1.933,1.992.379.379,0,0,1,.082.258.451.451,0,0,1-.094.27q-.176.246-.6.78t-.633.826a7.087,7.087,0,0,1,.481,1.148L17.66,7.3a.369.369,0,0,1,.246.147A.447.447,0,0,1,18,7.723Z"
                fill="#003f7d"
              />
            </svg>
          </div>
          <div class="sw-tile-value-row">
            <span class="sw-tile-value">{{ formatNumber(summaryTilesData?.settings?.count) }}</span>
          </div>
        </div>
        <span class="sw-tile-tag">{{
          getPreview(summaryTilesData?.settings?.latestSettingNames, 2, summaryTilesData?.settings?.count)
        }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { UserAdminSettingApi } from "@/api";

interface SummaryTilesData {
  styleAnalysis?: {
    count: number;
    latestStyleNames?: string[];
  };
  customers?: {
    count: number;
    topCustomerNames?: string[];
  };
  productType?: {
    count: number;
    productCategoriesCount?: number;
  };
  settings?: {
    count: number;
    latestSettingNames?: string[];
  };
}

function formatNumber(val: number | undefined): string {
  return (val ?? 0).toLocaleString();
}

function getPreview(items: string[] | undefined, visibleCount: number, total?: number): string {
  if (!items || items.length === 0) {
    return "";
  }
  const shown = items.slice(0, visibleCount);
  const visibleItems = shown.join(", ");
  const totalCount = typeof total === "number" ? total : items.length;
  const remainingCount = totalCount - shown.length;

  return remainingCount > 0 ? `${visibleItems} +${remainingCount}` : visibleItems;
}
export default defineComponent({
  name: "DashboardSummaryTiles",

  props: {
    summaryTilesData: {
      type: Object as PropType<SummaryTilesData>,
      required: true
    }
  },

  setup() {
    return {
      formatNumber,
      getPreview
    };
  },

  data() {
    return {
      // GSD V4 tenants don't use custom settings, so the Settings tile is hidden for them.
      isV4CalculationEngine: null as null | boolean
    };
  },

  async created(): Promise<void> {
    try {
      const res = await new UserAdminSettingApi().apiSystemConfigurationGet();
      this.isV4CalculationEngine =
        String(res.data.calculationEngineType?.defaultItem ?? "")
          .trim()
          .toLowerCase() === "gsdv4";
    } catch {
      this.isV4CalculationEngine = false;
    }
  }
});
</script>

<style scoped>
/* ─── Tile Strip ────────────────────────────────── */
.sw-tile-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 12px;
}
/* GSD V4 hides the Settings tile; the remaining three tiles share the full width. */
.sw-tile-strip-three {
  grid-template-columns: repeat(3, 1fr);
}
@media (max-width: 1100px) {
  .sw-tile-strip {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 700px) {
  .sw-tile-strip {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ─── Individual Tile Card ───────────────────────── */
.sw-count-tile {
  padding: 10px;
  flex-direction: column;
  gap: 0;
}

.sw-tile-clickable {
  cursor: pointer;
}

/* ─── Label (top) ────────────────────────────────── */
.sw-tile-label {
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-size: 11px;
  color: #8896ab;
  font-weight: 500;
  margin-bottom: 6px;
}

/* ─── Middle Row: icon + value ───────────────────── */
.sw-tile-mid {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

/* ─── Circular Icon ──────────────────────────────── */
.sw-tile-icon-wrap {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  flex-shrink: 0;
}
.tile-blue .sw-tile-icon-wrap {
  background: #cceffc;
  color: #0083b3;
}
.tile-teal .sw-tile-icon-wrap {
  background: #d1f0ea;
  color: #14866f;
}
.tile-orange .sw-tile-icon-wrap {
  background: #fed1aa;
  color: #d56a11;
}
.tile-grey .sw-tile-icon-wrap {
  background: #ccdded;
  color: #003f7d;
}

/* ─── Value ──────────────────────────────────────── */
.sw-tile-value {
  font-size: 30px;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1;
}

/* ─── Bottom Pill Tag ────────────────────────────── */
.sw-tile-tag {
  display: inline-block;
  font-size: 10px;
  letter-spacing: 0.4px;
  font-weight: 500;
  font-style: italic;
  padding: 2px 4px;
  border-radius: 5px;
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.tile-blue .sw-tile-tag {
  background: #cceffc;
  color: #0083b3;
}
.tile-teal .sw-tile-tag {
  background: #d1f0ea;
  color: #14866f;
}
.tile-orange .sw-tile-tag {
  background: #fed1aa;
  color: #d56a11;
}
.tile-grey .sw-tile-tag {
  background: #ccdded;
  color: #003f7d;
}
</style>
